<div class="bg-night border border-white/10 rounded-xl overflow-hidden overflow-x-hidden max-h-[90vh] flex flex-col">
  <div class="p-5 border-b border-white/10">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl bg-neon/20 flex items-center justify-center">
          <span class="material-symbols-outlined text-neon">group_add</span>
        </div>
        <div>
          <h2 class="text-lg font-semibold text-white">{{ 'pos.helpers.title' | translate }}</h2>
          <p class="text-sm text-white/50">{{ 'pos.helpers.subtitle' | translate }}</p>
        </div>
      </div>
      <button
        type="button"
        (click)="close()"
        class="w-8 h-8 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors">
        <span class="material-symbols-outlined text-white/70">close</span>
      </button>
    </div>
  </div>

  <div class="p-5 flex-1 overflow-y-auto">
    <div class="mb-6">
      <label class="block text-sm font-medium text-white/70 mb-2">
        {{ 'pos.helpers.add_helper' | translate }}
      </label>
      <mat-autocomplete
        #volunteerAuto="matAutocomplete"
        [displayWith]="displayVolunteer"
        (optionSelected)="onVolunteerSelected($event.option.value)">
        @for (volunteer of volunteerSearchResults(); track volunteer.id) {
          <mat-option [value]="volunteer">
            <div class="flex items-center gap-2 py-1">
              <div class="w-8 h-8 rounded-full bg-neon/20 flex items-center justify-center flex-shrink-0">
                <span class="material-symbols-outlined text-neon text-sm">person</span>
              </div>
              <div>
                <div class="text-white">{{ volunteer.firstName }} {{ volunteer.lastName }}</div>
                <div class="text-white/50 text-xs">{{ 'pos.helpers.role_volunteer' | translate }}</div>
              </div>
            </div>
          </mat-option>
        }
        @if (searchLoading()) {
          <mat-option disabled>
            <div class="flex items-center justify-center py-2">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          </mat-option>
        }
      </mat-autocomplete>
      <div class="relative">
        <span class="absolute left-4 top-1/2 -translate-y-1/2 material-symbols-outlined text-white/30">search</span>
        <input
          type="text"
          [formControl]="volunteerSearchControl"
          [matAutocomplete]="volunteerAuto"
          data-testid="helper-search-input"
          class="w-full bg-transparent border border-white rounded-full py-3 pl-12 pr-4 text-white placeholder-white/70 focus:outline-none focus:border-neon transition-all"
          placeholder="{{ 'pos.helpers.search_placeholder' | translate }}" />
      </div>
    </div>

    <div>
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-sm font-medium text-white/70">{{ 'pos.helpers.current_helpers' | translate }}</h3>
        @if (helpersLoading()) {
          <mat-spinner diameter="16"></mat-spinner>
        }
      </div>

      @if (helpers().length === 0 && !helpersLoading()) {
        <div class="text-center py-8">
          <div class="w-16 h-16 rounded-2xl bg-white/5 flex items-center justify-center mx-auto mb-3">
            <span class="material-symbols-outlined text-white/30 text-3xl">group_off</span>
          </div>
          <p class="text-white/50 text-sm">{{ 'pos.helpers.no_helpers' | translate }}</p>
        </div>
      } @else {
        <div class="space-y-2">
          @for (helper of helpers(); track helper.id) {
            <div
              class="flex items-center justify-between bg-white/5 rounded-xl p-3 border border-white/10 hover:border-white/20 transition-colors"
              data-testid="helper-item">
              <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-full bg-neon/20 flex items-center justify-center flex-shrink-0">
                  <span class="material-symbols-outlined text-neon">person</span>
                </div>
                <div>
                  <div class="text-white font-medium">{{ getHelperName(helper) }}</div>
                  <div class="text-white/50 text-xs flex items-center gap-1">
                    <span class="material-symbols-outlined text-xs">badge</span>
                    {{ 'pos.helpers.role_volunteer' | translate }}
                  </div>
                </div>
              </div>
              <button
                type="button"
                (click)="removeHelper(helper)"
                [disabled]="removingId() === helper.id"
                data-testid="remove-helper-button"
                class="w-8 h-8 rounded-full bg-red-500/10 hover:bg-red-500/20 flex items-center justify-center transition-colors disabled:opacity-50">
                @if (removingId() === helper.id) {
                  <mat-spinner diameter="16"></mat-spinner>
                } @else {
                  <span class="material-symbols-outlined text-red-400 text-lg">person_remove</span>
                }
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="p-5 border-t border-white/10">
    <button
      type="button"
      (click)="close()"
      class="w-full border border-white/20 text-white font-medium py-3 px-4 rounded-full hover:bg-white/10 transition-colors flex items-center justify-center gap-2">
      <span class="material-symbols-outlined">check</span>
      <span>{{ 'common.close' | translate }}</span>
    </button>
  </div>
</div>
